module.exports = __webpack_public_path__ + "static/media/naturgy01.719e1d6a.png";